import { RouteRecordRaw } from 'vue-router';
import { LoginPage } from '@/pages/auth';

export const routeName = 'Login';

export const route: RouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: LoginPage,
};
